let notifyFn = () => {
  console.warn('Notification system not initialized');
};

export const setNotify = (fn) => {
  notifyFn = fn;
};

export const notify = (message, options = {}) => {
  return notifyFn(message, options);
};

// Add method variants
notify.success = (message, options = {}) => {
  return notifyFn(message, { ...options, severity: 'success' });
};

notify.error = (message, options = {}) => {
  return notifyFn(message, { ...options, severity: 'error' });
};

notify.warning = (message, options = {}) => {
  return notifyFn(message, { ...options, severity: 'warning' });
};

notify.info = (message, options = {}) => {
  return notifyFn(message, { ...options, severity: 'info' });
};

notify.default = (message, options = {}) => {
  return notifyFn(message, { ...options, severity: 'default' });
};